import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ThemeCustomizerService } from '../components/theme-customizer/theme-customizer.service';
import { HeaderStyleTwoComponent } from '../components/header-style-two/header-style-two.component';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
})
export class ErrorPageComponent implements OnInit {

    isToggled = false;
	
    constructor(
        public themeService: ThemeCustomizerService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void {}

}